import dayjs from "dayjs";
import * as S from "./AlarmItem.style";
import { Buttons } from "../Buttons";
import { request } from "@/common/api";
import { useNavigate } from "react-router-dom";
import { BaseResponse } from "@/common/types/baseRespones";
import { GET_PUSH_ALARM } from "@/common/querykeys";
import { useState, useEffect } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";

interface AlarmItemProps {
  data: {
    id: string;
    body: string;
    type: string;
    title: string;
    route: string;
    status: string;
    createdAt?: string;
  };
}

export const AlarmItem = ({ data }: AlarmItemProps) => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const [isOpen, setIsOpen] = useState(false);
  const [isRead, setIsRead] = useState(data.status === "read");

  const { mutate: changeReadStatus } = useMutation({
    mutationFn: (payload: { id: string; status: string }) =>
      request<BaseResponse>({
        method: "PUT",
        url: "/push-alarm/read-alarm",
        data: payload,
      }),
    onSuccess: (_, variables) => {
      queryClient.setQueryData([GET_PUSH_ALARM], (oldData: any) => {
        if (!oldData) return oldData;
        return {
          ...oldData,
          data: oldData.data.map((item: any) =>
            item.id === variables.id ? { ...item, status: "read" } : item
          ),
        };
      });
    },
  });

  useEffect(() => {
    setIsRead(data.status === "read");
  }, [data.status]);

  const handleItemOpen = () => {
    setIsOpen((prev) => !prev);

    if (!isRead) {
      setIsRead(true);
      changeReadStatus({ id: data.id, status: "read" });
    }
  };

  return (
    <S.AlarmItem onClick={handleItemOpen}>
      <S.AlarmTit $readed={isRead}>
        <span>
          {data.type} <span>{isRead ? "읽음" : "읽지 않음"}</span>
        </span>
        <div>{data.title}</div>
      </S.AlarmTit>
      <S.AlarmDate>
        {data.createdAt
          ? dayjs(data.createdAt).format("YYYY-MM-DD HH:mm:ss")
          : ""}
      </S.AlarmDate>
      <S.AlarmBody $active={isOpen}>
        <div>{data.body}</div>
        {isOpen && (
          <div>
            <Buttons
              type="button"
              size="sm"
              layout="solid"
              color="primary100"
              label="이동하기"
              onClick={() => navigate(data.route)}
            />
          </div>
        )}
      </S.AlarmBody>
    </S.AlarmItem>
  );
};
